import React from 'react';
import PropTypes from 'prop-types';

import {Grid, Typography, FormGroup, Checkbox, Button, Popper} from 'views/components';
import {ArrowDropDown} from 'views/icons';
import {translate, Translate} from 'views/module';

const MessageTypeFilter = (props) => {
  const [open, setOpen] = React.useState(false);

  const anchorRef = React.useRef(null);

  const {
    messageTypeFilter,
    setMessageTypeFilter,
  } = props;

  const onCheckboxChange = (type) => {
    const nextFilter = {...messageTypeFilter};
    nextFilter[type] = !nextFilter[type];
    setMessageTypeFilter(nextFilter);
  };

  const onToggleDropDown = () => {
    setOpen((prevOpen) => !prevOpen);
  };

  const onClickAway = () => {
    setOpen(false);
  };

  return (
    <>
      <Button
        anchorref={anchorRef}
        variant='text'
        endIcon={<ArrowDropDown/>}
        onClick={onToggleDropDown}
        sx={{
          textTransform: 'none',
          fontSize: '12px',
          fontWeight: 500,
          color: '#484442',
          textAlign: 'right',
        }}
      >
        <Translate expression='career.jobDetail.Messages.Filter'/>
      </Button>
      <Popper
        open={open}
        anchorEl={anchorRef.current}
        onClickAway={onClickAway}
        GrowSx={{
          border: '1px solid rgba(0, 0, 0, 0.12)',
          borderRadius: '4px',
          boxSizing: 'border-box',
          boxShadow: '0px 3px 1px rgba(0, 0, 0, 0.2), 0px 2px 2px rgba(0, 0, 0, 0.14), 0px 1px 5px rgba(0, 0, 0, 0.12)',
          pl: 1,
          py: 1,
        }}
      >
        <Grid container direction='column' spacing={0.5}>
          <Grid item xs={12}>
            <Typography variant='subtitle1' sx={{fontWeight: 500}}>
              <Translate expression='career.jobDetail.Messages.Filter'/>
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <FormGroup sx={{pl: 2}}>
              <Checkbox
                label={translate('career.jobDetail.Messages.Type.Comments')}
                checked={messageTypeFilter.COMMENTS}
                onChange={() => onCheckboxChange('COMMENTS')}
              />
              <Checkbox
                label={translate('career.jobDetail.Messages.Type.Announcements')}
                checked={messageTypeFilter.ANNOUNCEMENTS}
                onChange={() => onCheckboxChange('ANNOUNCEMENTS')}
              />
            </FormGroup>
          </Grid>
        </Grid>
      </Popper>
    </>
  );
};

MessageTypeFilter.propTypes = {
  messageTypeFilter: PropTypes.shape({
    ANNOUNCEMENTS: PropTypes.bool.isRequired,
    COMMENTS: PropTypes.bool.isRequired,
  }).isRequired,
  setMessageTypeFilter: PropTypes.func.isRequired,
};

export default React.memo(MessageTypeFilter);
